module.exports = __webpack_public_path__ + "img/italiansped-logo.1cac1a6a.png";